module.exports = __webpack_public_path__ + "img/patty_hero_desktop.26c75879.png";